import React from "react";
import { Drawer } from "@mui/material";

export const FormDrawer = ({ children, title, width = 550, ...props }) => {
  return (
    <Drawer
      anchor="right"
      PaperProps={{
        sx: { width, maxWidth: "100%" },
      }}
      {...props}
      className="relative"
    >
      {!!title && (
        <div className="sticky top-0 z-10 flex-shrink-0 bg-white py-4 px-6 text-lg font-medium shadow-sm dark:bg-slate-800">
          {title}
        </div>
      )}

      <div className="flex flex-grow flex-col">{children}</div>
    </Drawer>
  );
};

export default FormDrawer;
